import React from 'react';
import moment from 'moment';
import WineIcon from 'react-icons/lib/io/wineglass';
import DeleteIcon from 'react-icons/lib/io/android-remove-circle';
import PlusIcon from 'react-icons/lib/io/android-add-circle';

import { removeDrink, addDrink } from '../actions/drinks';

class Drink extends React.Component {

  remove = () => {
    removeDrink(this.props.timestamp);
  }

  drinkAnother = () => {
    const { sd, abv, volume } = this.props;
    addDrink({
      sd,
      abv,
      volume,
    });
  }

  render() {
    const { sd, timestamp, completionPercentage } = this.props;

    const gradient = `linear-gradient(to right, #f3f3f3 0%, #f3f3f3 ${completionPercentage}%, white ${completionPercentage}%, white 100%)`

    return (
      <div className="drink-list-item" style={{ background: gradient }}>
        <WineIcon className="icon" />
        <span>{sd} @ {moment(timestamp).format('h:mma')}</span>
        <DeleteIcon className="icon" onClick={this.remove} />
        <PlusIcon className="icon" onClick={this.drinkAnother} />
        <div className="progress-bar" style={{ width: `{completionPercentage}%`}} />
      </div>
    );
  }

}

export default Drink;



// WEBPACK FOOTER //
// ./src/components/drink-list-item.js